import { render } from "./ProjectSummaryUpdate.vue?vue&type=template&id=54d71b57"
import script from "./ProjectSummaryUpdate.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__